/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface SkillMapFieldPayload {
    cmId: string;
}

export interface SkillMapFieldResponse {
    careerMapName: string;
    fieldlevelOne: SkillMapFieldItem[];
    fieldlevelTwo: SkillMapFieldItem[];
    fieldlevelThree: SkillMapFieldItem[];
}

export interface SkillMapFieldItem {
    fieldTitle: string;
    fieldId: string;
    fieldLevel: string;
    parentFieldId: string;
}

class SkillMapFieldService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "skillMapField");
    }

    public async skillMapField(payload: SkillMapFieldPayload, resolved: (response: SkillMapFieldResponse) => void, rejected: (error: any) => void) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as SkillMapFieldResponse;
                resolved(response);
            },
            rejected
        );
    }

    public async postResponse(payload: SkillMapFieldPayload): Promise<SkillMapFieldResponse> {
        return super.postWithPromise(payload).then((json: any) => {
            const response = json as SkillMapFieldResponse;
            return response;
        });
    }
}

export default SkillMapFieldService;
